import React, { useState } from 'react';
import { Box, Button, Typography, Collapse } from '@mui/material';
import { ContentCopy as CopyIcon, QrCode2 as QrIcon, Check as CheckIcon } from '@mui/icons-material';
import { QRCodeSVG } from 'qrcode.react';
import { PanelItem, copiar } from '@/services/aprovador';

/** Código para pagar no app: linha digitável formatada ou PIX copia-e-cola, com botão copiar e QR. */
const CodigoPagamento: React.FC<{ item: PanelItem }> = ({ item }) => {
  const [copiado, setCopiado] = useState(false);
  const [qr, setQr] = useState(false);

  const isPix = item.kind === 'pix_copia_cola' && !!item.pixPayload;
  const raw = isPix ? item.pixPayload! : item.kind === 'pix_chave' ? item.pixKey : item.barcode;
  if (!raw) return null;
  const mostrar = isPix ? item.pixPayload! : item.kind === 'pix_chave' ? item.pixKey! : (item.barcodeFormatted || item.barcode!);
  const rotulo = isPix ? 'PIX copia e cola' : item.kind === 'pix_chave' ? `Chave PIX${item.pixKeyType ? ` (${item.pixKeyType})` : ''}` : item.subtype === 'arrecadacao' ? 'Código da guia' : 'Linha digitável';

  const onCopy = async () => {
    if (await copiar(raw)) {
      setCopiado(true);
      setTimeout(() => setCopiado(false), 2000);
    }
  };

  return (
    <Box sx={{ bgcolor: '#f6f8fb', border: '1px solid #e3e8ef', borderRadius: 2, p: 1.5 }}>
      <Typography variant="caption" color="text.secondary" fontWeight={600}>{rotulo}</Typography>
      <Typography
        sx={{ fontFamily: 'ui-monospace, SFMono-Regular, Menlo, monospace', fontSize: 13, wordBreak: 'break-all', mt: 0.5, userSelect: 'all',
          maxHeight: isPix ? 72 : 'none', overflow: 'hidden' }}
      >
        {mostrar}
      </Typography>
      <Box sx={{ display: 'flex', gap: 1, mt: 1, flexWrap: 'wrap' }}>
        <Button size="small" variant={copiado ? 'contained' : 'outlined'} color={copiado ? 'success' : 'primary'}
          startIcon={copiado ? <CheckIcon /> : <CopyIcon />} onClick={onCopy}>
          {copiado ? 'Copiado' : 'Copiar código'}
        </Button>
        {isPix && (
          <Button size="small" startIcon={<QrIcon />} onClick={() => setQr((v) => !v)}>{qr ? 'Ocultar QR' : 'Ver QR'}</Button>
        )}
      </Box>
      {isPix && (
        <Collapse in={qr} unmountOnExit>
          <Box sx={{ display: 'flex', justifyContent: 'center', mt: 1.5, bgcolor: '#fff', p: 1, borderRadius: 1 }}>
            <QRCodeSVG value={item.pixPayload!} size={200} level="M" includeMargin />
          </Box>
        </Collapse>
      )}
    </Box>
  );
};

export default CodigoPagamento;
